import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './personalDetails';
import ContactDetails from './contactDetails';
import DocumentDetails from './documentDetails';
import Activity from './activity';
import GLAccount from './GLAccounts';
import PreferenceDetails from './preference';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import AddressDetails from './additionalAddress';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import DependentDetails from './dependentDetails';

const UpdateCustomerMaster = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const { currencyPrecision } = useCurrency();
    const userName = useSelector(getName);
    const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
    const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false, false]);
    const [loading, setloader] = useState(false)
    const [contactList, setContactList] = useState([])
    const [addressList, setAddressList] = useState([])
    const [documentsList, setDocumentsList] = useState([])
    const [activityList, setActivityList] = useState([])
    const [preferenceList, setPreferenceList] = useState([])
    const [sourceList, setSourceList] = useState([]);
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [salesPersonList, setSalesPersonList] = useState([]);
    const [leadStatus, setLeadStatus] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [packageName, setPackageName] = useState([]);
    const [propertylist, setPropertyList] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [leadType, setLeadType] = useState([]);
    const [dependentList, setDependentList] = useState([]);
    const [personalTabLeadType, setPersonalTabLeadType] = useState([]);
    const [activityRating, setActivityRating] = useState([]);
    const [language, setLanguage] = useState([]);
    const [woContact, setWOContact] = useState([]);
    const [activityStatus, setActivityStatus] = useState([]);
    const [ativityLeadType, setActivityLeadType] = useState([]);
    const [categoryMix, setCategoryMix] = useState([]);
    const [taxList, setTaxList] = useState([]);
    const [acountCodes, setAccountCodes] = useState([]);
    const [addContactType, setAddContactType] = useState([]);
    const [addAddressType, setAddAddressType] = useState([]);
    const [documentType, setDocumentType] = useState([]);
    const [prefIntrest, setPrefIntrest] = useState([]);
    const [prefBuying, setPrefBuying] = useState([]);
    const [locationMaster, setLocationMaster] = useState([]);
    const [UnitClass, setUnitClass] = useState([]);
    const [Properties, setProperties] = useState([]);
    const [UnitView, setUnitView] = useState([]);
    const [UnitTypeDesc, setUnitTypeDesc] = useState([]);
    const [UnitModel, setUnitModel] = useState([]);
    const [bedRooms, setBedRooms] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [countriesList, setCountries] = useState([]);
    const [nationalityList, setNationalitylist] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [loader, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);

    const location = useLocation();
    const userData = location.state;

    const validationRules = [
        { key: "type", message: "Please Select Type from Personal Details" },
        { key: "title", message: "Please Select Title from Personal Details" },
        { key: "fullName", message: "Please Enter FullName" },
        { key: "mobileNo", message: "Please Enter Mobile No" },
        { key: "email", message: "Please Enter Email" },
        { key: "leadtype", message: "Please Enter Lead Type" },
        { key: "nationality", message: "Please Enter Nationality" },
        { key: "source", message: "Please Enter Source" },
        { key: "subsource", message: "Please Enter Sub Source" },
        { key: "salesPerson", message: "Please Enter Sales Person" },
        // { key: "dateofBirth", message: "Please Enter Date Of Birth" },
    ];
    const [gLAccounts, setGLAccounts] = useState({
        subgroup: null,
        accountcode: null,
        accountname: null,
        createledger: false,
        sgAccount: null,
        dateofBirth: null,
        vatNo: "",
        birthPlace: "",
        remarks: "",
        idNo: "",
        taxCode: null,
        issueDate: null,
        expiryDate: null,
        countryIssue: null,
        categoryMix: null,
    });
    const [transectionData, setTransectionData] = useState({
        salesPerson: '',
        type: '',
        mobileNo: '',
        agent: '',
        fullName: '',
        title: '',
        email: '',
        firstName: '',
        gender: '',
        lastName: '',
        phoneNo: '',
        poBox: '',
        categoryMix: '',
        salesPerson: '',
        address: '',
        dateofBirth: '',
        firstNameAR: '',
        lastNameAR: '',
        addressAR: '',
        source: '',
        designatoin: '',
        subsource: '',
        leadtype: '',
        countryCode: '',
        companyName: '',
        designation: '',
        nationality: null,
        productType: null,
    });

    useEffect(() => {
        setUserDate()
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    const setUserDate = async () => {
        try {
            setLoading(true)
            setTableLoading(true)
            const params1 = new URLSearchParams();
            params1.append('dropdownTypes', 'CustSource,SalesPersons,CustomerType,CustTitles,CustSource,CustAgents,LeadType,ActivityRating,CustPackageNames,PersonalTabLeadType');
            const res1 = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params1.toString()}`);
            setSourceList(res1?.data?.dropdowns?.CustSource)
            setCustomerTypeList(res1?.data?.dropdowns?.CustomerType)
            setSalesPersonList(res1?.data?.dropdowns?.SalesPersons)
            setAgentList(res1?.data?.dropdowns?.Agents)
            setPackageName(res1?.data?.dropdowns?.CustPackageNames)
            setTitleList(res1?.data?.dropdowns?.CustTitles)
            setLeadType(res1?.data?.dropdowns?.LeadType)
            setPersonalTabLeadType(res1?.data?.dropdowns?.PersonalTabLeadType)
            setActivityRating(res1?.data?.dropdowns?.ActivityRating)
            // DropDown 2nd List

            const params2 = new URLSearchParams();
            params2.append('dropdownTypes', 'CategoryMix,TaxMaster,AccountCodes,AddContactType,AddAddressType,DocumentType,PrefIntrest,PrefBuying,LocationMaster,ActivityWayofContact,ActivityLanguage');
            const res2 = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params2.toString()}`);
            setCategoryMix(res2?.data?.dropdowns?.CategoryMix)
            setTaxList(res2?.data?.dropdowns?.TaxMaster)
            setAccountCodes(res2?.data?.dropdowns?.AccountCodes)
            setAddContactType(res2?.data?.dropdowns?.AddContactType)
            setAddAddressType(res2?.data?.dropdowns?.AddAddressType)
            setDocumentType(res2?.data?.dropdowns?.DocumentType)
            setPrefIntrest(res2?.data?.dropdowns?.PrefIntrest)
            setPrefBuying(res2?.data?.dropdowns?.PrefBuying)
            setLocationMaster(res2?.data?.dropdowns?.LocationMaster)
            setLanguage(res2?.data?.dropdowns?.ActivityLanguage)
            setWOContact(res2?.data?.dropdowns?.ActivityWayofContact)
            // DropDown 3rd List

            const params3 = new URLSearchParams();
            params3.append('dropdownTypes', 'UnitClass,Properties,UnitView,UnitTypeDesc,UnitModel,BedRooms,Country,Nationality,PrefProperties,ActivityLeadType,ActivityStatus');
            const res3 = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params3.toString()}`);
            setUnitClass(res3?.data?.dropdowns?.UnitClass)
            setProperties(res3?.data?.dropdowns?.Properties)
            setUnitView(res3?.data?.dropdowns?.UnitView)
            setUnitTypeDesc(res3?.data?.dropdowns?.UnitTypeDesc)
            setUnitModel(res3?.data?.dropdowns?.UnitModel)
            setBedRooms(res3?.data?.dropdowns?.BedRooms)
            setCountries(res3?.data?.dropdowns?.Country)
            setNationalitylist(res3?.data?.dropdowns?.Nationality)
            setPropertyList(res3?.data?.dropdowns?.PrefProperties)
            setActivityLeadType(res3?.data?.dropdowns?.ActivityLeadType)
            setActivityStatus(res3?.data?.dropdowns?.ActivityStatus)

            const params = new URLSearchParams();
            params.append('Action', "GetCustomerDetailsByCustomerNo");
            params.append('TenantNo', userData?.customerNo);
            const res = await apiService.getApiParamater('CUSTOMER_COMMON', `?${params.toString()}`);
            let usrDAta = res?.data?.result?.data
            const selectedtax = res2?.data?.dropdowns?.TaxMaster?.find(item => item.value === usrDAta.TaxCode?.toString());
            setSelectedCountry(usrDAta?.Maincountry ? { label: usrDAta.Maincountry, value: usrDAta.Maincountry } : null)
            setSelectedCity(usrDAta?.Maincity ? { label: usrDAta.Maincity, value: usrDAta.Maincity } : null)
            setTransectionData(prev => ({
                ...prev,
                type: usrDAta?.Customertype ? { label: usrDAta.Customertype === "0" ? "" : usrDAta.Customertype, value: usrDAta.Customertype } : null,
                title: usrDAta?.Title ? { label: usrDAta.Title === "0" ? "" : usrDAta.Title, value: usrDAta.Title } : null,
                fullName: usrDAta?.Customer_Name === "0" ? "" : usrDAta?.Customer_Name || "",
                firstName: usrDAta?.Occupation === "0" ? "" : usrDAta?.Occupation || "",
                lastName: usrDAta?.Department === "0" ? "" : usrDAta?.Department || "",
                email: usrDAta?.Email_id === "0" ? "" : usrDAta?.Email_id || "",
                mobileNo: (usrDAta?.Exp6 + usrDAta?.MainContactno) || "",
                status: usrDAta?.Status === "0" ? "" : usrDAta?.Status || "Active",
                address: usrDAta?.Mainaddress1 === "0" ? "" : usrDAta?.Mainaddress1 || "",
                poBox: usrDAta?.POBox === "0" ? "" : usrDAta?.POBox || "",
                country: usrDAta?.Maincountry ? { label: usrDAta.Maincountry === "0" ? "" : usrDAta?.Maincountry, value: usrDAta.Maincountry } : null,
                city: usrDAta?.Maincity ? { label: usrDAta.Maincity === "0" ? "" : usrDAta.Maincity, value: usrDAta.Maincity } : null,
                nationality: usrDAta?.Nationality ? { label: usrDAta.Nationality === "0" ? "" : usrDAta.Nationality, value: usrDAta.Nationality } : null,
                source: usrDAta?.Source ? { label: usrDAta.Source === "0" ? "" : usrDAta.Source, value: usrDAta.Source } : null,
                agent: usrDAta?.Agent ? { label: usrDAta.Agent === "0" ? "" : usrDAta.Agent, value: usrDAta.Agent } : null,
                salesPerson: usrDAta?.SalesPerson ? { label: usrDAta.SalesPerson === "0" ? "" : usrDAta.SalesPerson, value: usrDAta.SalesPerson } : null,
                leadtype: usrDAta?.Exp4 ? { label: usrDAta.Exp4 === "0" ? "" : usrDAta.Exp4, value: usrDAta.Exp4 } : null,
                subsource: usrDAta?.Exp5 ? { label: usrDAta.Exp5 === "0" ? "" : usrDAta.Exp5, value: usrDAta.Exp5 } : null,
                productType: usrDAta?.Exp16 ? { label: usrDAta.Exp16 === "0" ? "" : usrDAta.Exp16, value: usrDAta.Exp16 } : null,
                gender: usrDAta?.Exp14 ? { label: usrDAta.Exp14 === "0" ? "" : usrDAta.Exp14, value: usrDAta.Exp14 } : null,
                firstNameAR: usrDAta?.Exp1 === "0" ? "" : usrDAta?.Exp1 || "",
                lastNameAR: usrDAta?.Exp2 === "0" ? "" : usrDAta?.Exp2 || "",
                addressAR: usrDAta?.Exp9 === "0" ? "" : usrDAta?.Exp9 || "",
                designation: usrDAta?.Contactaddress === "0" ? "" : usrDAta?.Contactaddress || "",
                countryCode: usrDAta?.Exp6 ? { dialCode: usrDAta.Exp6 } : null,
                dateofBirth: usrDAta?.Cdate === "0" ? "" : usrDAta?.Cdate || null,
                companyName: usrDAta?.Exp8 === "0" ? "" : usrDAta?.Exp8 || "",
            }));
            setGLAccounts(prev => ({
                ...prev,
                accountcode: usrDAta?.AccountCode === "0" ? "" : usrDAta?.AccountCode || "",
                accountname: usrDAta?.AccountName === "0" ? "" : usrDAta?.AccountName || "",
                sgAccount: usrDAta?.SGCode === "0" ? "" : usrDAta?.SGCode || "",
                vatNo: usrDAta?.VATRegNo === "0" ? "" : usrDAta?.VATRegNo || "",
                taxCode: usrDAta?.TaxCode ? { label: selectedtax.text || null, value: selectedtax || null } : null,
                remarks: usrDAta?.Remarks === "0" ? "" : usrDAta?.Remarks || "",
                idNo: usrDAta?.TradeLicNo === "0" ? "" : usrDAta?.TradeLicNo || "",
                issueDate: usrDAta?.TL_issue_date === "0" ? "" : usrDAta?.TL_issue_date || null,
                expiryDate: usrDAta?.TL_Expiry_date === "0" ? "" : usrDAta?.TL_Expiry_date || null,
                categoryMix: usrDAta?.Category_Mix ? { label: usrDAta.Category_Mix || null, value: usrDAta.Category_Mix || null } : null,
                dateofBirth: usrDAta?.Cdate === "0" ? "" : usrDAta?.Cdate || null,
            }));

            const contactparams = new URLSearchParams();
            contactparams.append('Action', "GetAdditionalContactsByCustomerNo");
            contactparams.append('TenantNo', userData?.customerNo);
            const ContactRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${contactparams.toString()}`);
            let contactData = ContactRes?.data?.result?.data
            const normalizeArray = (data) =>
                Array.isArray(data) ? data : data ? [data] : [];

            const rawContactData = normalizeArray(ContactRes?.data?.result?.data);

            const mappedContacts = rawContactData.map(item => ({
                type: { label: item?.contact_type_id, value: item?.contact_type_id } || null,
                contactPerson: item?.ContactPersonBI || '',
                phone: item?.contact_no || '',
                id: item?.cd_id,
                countryCode: item?.country_code || '',
            }));

            setContactList(mappedContacts);

            const addressparams = new URLSearchParams();
            addressparams.append('Action', "GetAdditionalAddressByCustomerNo");
            addressparams.append('TenantNo', userData?.customerNo);
            const addressRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${addressparams.toString()}`);
            const rawAddressData = normalizeArray(addressRes?.data?.result?.data);
            const mappedAddresses = rawAddressData.map(item => ({
                type: { label: item?.ADDRESS_TYPE_ID, value: item?.ADDRESS_TYPE_ID } || null,
                poBox: item?.POBOX || '',
                id: item?.CD_ID,
                address1: item?.LINE1 || '',
                address2: item?.LINE2 || '',
                country: { label: item?.COUNTRY_CODE, value: item?.COUNTRY_CODE } || null,
                city: { label: item?.CITY_CODE, value: item?.CITY_CODE } || null,
            }));


            const dependentParam = new URLSearchParams();
            dependentParam.append('Action', "GetDependentsByCustomerNo");
            dependentParam.append('TenantNo', userData?.customerNo);
            const dependentRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${dependentParam.toString()}`);
            const rawData = normalizeArray(dependentRes?.data?.result?.data);
            const mappDependent = rawData.map(item => ({
                type: { label: item?.RelationType, value: item?.RelationType } || null,
                recordId: item?.RecordId,
                name: item?.DependentName || '',
                email: item?.EmailId === "0" ? '' : item?.EmailId,
                address: item?.Address === "0" ? '' : item?.Address || '',
                mobileNo: item?.MobileNo === "0" ? '' : item?.MobileNo || '',
                passport: item?.PassportNo === "0" ? '' : item?.PassportNo || '',
                age: item?.Age === 0 ? '' : item?.Age || '',
                poBox: item?.PoBoxNo === "0" ? '' : item?.PoBoxNo || '',
                occupation: item?.Occupation === "0" ? '' : item?.Occupation || '',
                dateofBirth: item?.DateOfBirth === "1899-12-31T00:00:00" ? '' : item?.DateOfBirth || '',
                nationality: { label: item?.Nationality === "0" ? '' : item?.Nationality, value: item?.Nationality } || null,
                country: { label: item?.Country === "0" ? '' : item?.Country, value: item?.Country } || null,
                city: { label: item?.City === "0" ? '' : item?.City, value: item?.City } || null,
                gender: { label: item?.Gender === "0" ? '' : item?.Gender, value: item?.Gender } || null,
            }));
            setAddressList(mappedAddresses);
            setDependentList(mappDependent);
            setTableLoading(false)

        } catch (error) {
            console.error('Error fetching Customer data:', error);
            setTableLoading(false)

        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            for (const rule of validationRules) {
                if (!transectionData?.[rule.key]) {
                    setloader(false);
                    toast.warning(rule.message);
                    return;
                }
            }
            if (!/^\S+@\S+\.\S+$/.test(transectionData.email)) {
                setloader(false);
                toast.warning("Please Enter Valid Email");
                return;
            }
            let fullName = (transectionData?.firstName + " " + transectionData?.lastName)
            // const validParam = new URLSearchParams();
            // validParam.append('Action', 'CheckPrimaryContact');
            // validParam.append('TenantNo', '0');
            // validParam.append('TenantName', fullName);
            // validParam.append('CustomerType', transectionData?.countryCode?.dialCode);
            // validParam.append('UnitRefNo', transectionData?.mobileNo);
            // const validRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${validParam.toString()}`);
            // const value = Object.values(validRes?.result?.data || {})[0];
            // if (value) {
            //     setloader(false);
            //     toast.warning("User with this name already exists");
            //     return;
            // }
            const countryCode = transectionData?.countryCode?.dialCode?.toString() || "";
            const phoneWithoutCode = transectionData?.mobileNo?.toString().startsWith(countryCode)
                ? transectionData.mobileNo.toString().slice(countryCode.length)
                : transectionData.mobileNo;
            let customerMaster = {
                record_id: userData?.recordId,
                customertype: transectionData.type?.label || "",
                customer_no: userData?.customerNo,
                title: transectionData.title?.label,
                customer_Name: fullName || "",
                poBox: transectionData.poBox || "",
                mainaddress1: transectionData.address,
                mainaddress2: "0",
                maincountry: selectedCountry?.label || "",
                maincity: selectedCity?.label || "",
                mainContactno: phoneWithoutCode || "0",
                nationality: transectionData.nationality?.label || "0",
                source: transectionData.source?.label || "0",
                salesPerson: transectionData.salesPerson?.label || "0",
                agent: transectionData.agent?.label || "0",
                remarks: gLAccounts.remarks || "0",
                tradeLicNo: gLAccounts.idNo || "0",
                tL_issue_date: gLAccounts.issueDate || "01-jan-1900",
                tL_Expiry_date: gLAccounts.expiryDate || "01-jan-1900",
                permitted_Use: "0",
                category_Mix: gLAccounts.categoryMix?.label || "",
                contactPerson: "0",
                contactPersonNo: "0",
                email_id: transectionData.email || "0",
                occupation: transectionData?.firstName || "0",
                contactaddress: transectionData?.designation || "0",
                designation: "0",
                department: transectionData?.lastName || "0",
                cpNationality: transectionData.nationality?.label || "",
                cdate: gLAccounts.dateofBirth || "01-jan-1900",
                status: "Active",
                exp1: transectionData.firstNameAR || "",
                exp2: transectionData.lastNameAR || "",
                exp3: currentDatetimeUTC,
                modify_by: userName || "",
                modify_on: currentDatetimeUTC,
                createdBy: userName || "",
                createdOn: currentDatetimeUTC,
                accountCode: gLAccounts.accountcode || "0",
                accountName: gLAccounts.accountname || "0",
                sgCode: gLAccounts.sgAccount || "0",
                exp4: transectionData?.leadtype?.label || "0",
                exp5: transectionData?.subsource?.label || "0",
                exp6: countryCode === "+973" ? countryCode : ("+" + countryCode) || "0",
                exp7: "0",
                exp8: transectionData?.companyName || fullName || "0",
                exp9: transectionData?.addressAR || "0",
                exp10: "0",
                exp11: "0",
                exp12: "0",
                exp13: "0",
                exp14: transectionData?.gender?.label || "0",
                exp15: "0",
                exp16: transectionData?.productType?.label || "0",
                exp17: "0",
                vatRegNo: gLAccounts.vatNo || "0",
                taxCode: gLAccounts?.taxCode?.value || 0,
                leadtype: transectionData.leadtype?.label || "0"
            }
            const additionalContatList = contactList?.map((item, index) => {
                return {
                    cd_id: parseInt(item?.id) || 0,
                    customer_id: userData?.customerNo,
                    contact_type: item?.type?.label || "0",
                    country_code: "0",
                    area_code: "0",
                    contact_no: item?.phone || "0",
                    contactPersonBI: item?.contactPerson || "0"
                };
            });
            const activityLists = activityList?.map((item, index) => {
                return {
                    recordId: 0,
                    activityId: 0,
                    leadId: item?.name || "0",
                    customerNo: item?.name || "0",
                    customerName: item?.name || "0",
                    activityType: item?.type?.label || "0",
                    activityPurpose: item?.name || "0",
                    activityFromDate: "2025-12-21T05:52:41.499Z",
                    activityToDate: "2025-12-21T05:52:41.499Z",
                    description: item?.name || "0",
                    status: item?.name || "0",
                    priority: item?.name || "0",
                    assignedTo: item?.name || "0",
                    remarks: item?.name || "0",
                    exp1: item?.name || "0",
                    exp2: item?.name || "0",
                    exp3: item?.name || "0",
                    exp4: item?.name || "0",
                    exp5: item?.name || "0",
                    createdBy: userName || "0",
                    createdOn: currentDatetimeUTC,
                    modifiedBy: userName || "0",
                    modifiedOn: currentDatetimeUTC
                };
            });
            const customerDocumetsList = documentsList?.map((item, index) => {
                return {
                    customer_No: "0",
                    document_Type: item?.type?.label || "0",
                    document_No: item?.documentNo || "0",
                    document_Desc: item?.Remarks || "0",
                    doc_IssueDate: item?.IssueDate || "0",
                    doc_ExpiryDate: item?.expiryDate || "0",
                    document_Path: item?.name || "0"
                };
            });
            const preferencesList = preferenceList?.map((item, index) => {
                return {
                    recordId: 0,
                    leadId: "0",
                    customerNo: "0",
                    interest: item?.interest?.label || "0",
                    community: item?.community || "0",
                    location: item?.location?.label || "0",
                    property: item?.project?.label || "0",
                    unit: item?.unitNo?.label || "0",
                    unitType: item?.unitType?.label || "0",
                    unitView: item?.view?.label || "0",
                    floor: "0",
                    bedrooms: item?.bedroom?.label || "0",
                    budgetFrom: item?.budgetfrom || "0",
                    budgetTo: item?.budgetTo || "0",
                    unitArea: item?.unitArea || "0",
                    exp1: "0",
                    exp2: "0",
                    exp3: "0",
                    exp4: "0",
                    exp5: "0",
                    createdBy: userName || "0",
                    createdOn: currentDatetimeUTC,
                    modifiedBy: userName || "0",
                    modifiedOn: currentDatetimeUTC
                };
            });
            const additionalAddressList = addressList?.map((item, index) => {
                return {
                    cD_ID: item?.id || "0",
                    customeR_ID: userData?.customerNo,
                    addresS_TYPE_ID: item?.type?.label || "0",
                    pobox: item?.poBox || "0",
                    linE1: item?.address1 || "0",
                    linE2: item?.address2 || "0",
                    linE3: "0",
                    countrY_CODE: item?.country?.label || "0",
                    citY_CODE: item?.city?.label || "0"
                };
            });
            const getSearchCustomerList = [
                {
                    recordId: 0,
                    customerNo: "0",
                    accountCode: "0",
                    customerType: transectionData?.type?.label || "0",
                    customerName: fullName || "0",
                    contactNo: transectionData?.phoneNo || "0",
                    emailId: transectionData?.email || "0",
                    salesPerson: transectionData?.salesPerson?.label || "0",
                    source: transectionData?.source?.label || "0",
                    nationality: transectionData?.nationality?.label || "0",
                    agent: transectionData?.agent?.label || "0",
                    city: selectedCity?.label || "0",
                    country: selectedCountry?.label || "0",
                    createdBy: userName || "0",
                    createdOn: currentDatetimeUTC,
                    modifiedBy: userName || "0",
                    modifiedOn: currentDatetimeUTC
                }
            ]
            const tenantDependentList = dependentList?.map((item, index) => {
                return {
                    recordId: 0,
                    customer_No: "0",
                    relationType: item?.type?.label || "0",
                    dependentName: item?.name || "0",
                    gender: item?.gender?.label || "0",
                    age: parseInt(item?.age) || 0,
                    dateOfBirth: moment(item?.dateofBirth || "1900-01-01").format() || "1900-01-01T07:16:06.672Z",
                    occupation: item?.occupation || "0",
                    emailId: item?.email || "0",
                    mobileNo: item?.mobileNo || "0",
                    passportNo: item?.passport || "0",
                    issueDate: "1900-01-01T07:16:06.672Z",
                    expiryDate: "1900-01-01T07:16:06.672Z",
                    nationality: item?.nationality?.label || "0",
                    country: item?.country?.label || "0",
                    city: item?.city?.label || "0",
                    address: item?.address || "0",
                    poBoxNo: item?.poBox || "0",
                    createdBy: userName
                };
            });
            
            const body = {
                customerMain: {
                    customerMaster: customerMaster,
                    additionalContatList: additionalContatList,
                    activityList: activityLists,
                    customerDocumetsList: customerDocumetsList,
                    preferencesList: preferencesList,
                    additionalAddressList: additionalAddressList,
                    getSearchCustomerList: getSearchCustomerList,
                    tenantDependentList: tenantDependentList,
                    createLedger: gLAccounts?.createledger || false,
                    custNo: "0",
                    rblExpiredDocs: "0"
                }
            };
            const postRes = await apiService.put('EDIT_CUSTOMER', body);
            if (postRes?.data?.statusCode === 201) {
                toast.success(postRes?.data?.message);
                setloader(false);
                navigate('/Lease/Management/Master/Customer/Listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleCountryChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'CustCityDescByCountry');
        params.append('CascadText', selectedOption?.label);
        const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
        setCityList(res?.data?.items)
        setSelectedCountry(selectedOption);
        setSelectedCity(null);
        // fetchCities(selectedOption)
    }
    return (
        <div className="p-3">
            {/* Filters */}
            <div className='border-box2 p-2 d-flex gap-3 end' style={{ borderRadius: "8px" }}>

                {loading === true ?
                    <div className='mainbtn flex-end gap-2'>
                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                    </div>
                    :
                    <div className='mainbtn flex-end gap-2' onClick={handleSave}>
                        <FaSave color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Save</div>
                    </div>
                }
                <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                    <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                    <div className='center'>Back</div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Personal Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(4)} >Other Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Additional Contact
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 7 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(7)}>Additional Address
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 8 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(8)} >Dependent Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)} >Documents Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 5 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(5)} >Preference
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)} >Activity
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 6 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(6)} >Deal
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<PersonalDetails tableLoading={tableLoading} nationalityList={nationalityList} countriesList={countriesList} cityList={cityList} handleCountryChange={handleCountryChange} sourceList={sourceList} customerTypeList={customerTypeList} salesPersonList={salesPersonList} selectedCity={selectedCity}
                setTransectionData={setTransectionData} leadStatus={leadStatus} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} setSelectedCity={setSelectedCity}
                transectionData={transectionData} agentList={agentList} titleList={titleList} leadType={personalTabLeadType} categoryMix={categoryMix}
                defaultCountry={defaultCountry} packageName={packageName} />)}
            {gridVisibility[1] && (<ContactDetails setContactList={setContactList} addContactType={addContactType}
                contactList={contactList}
                currencyPrecision={currencyPrecision}
                defaultCountry={defaultCountry} />)}
            {gridVisibility[7] && (<AddressDetails setAddressList={setAddressList} addAddressType={addAddressType}
                addressList={addressList} countriesList={countriesList} cityList={cityList}
                currencyPrecision={currencyPrecision}
                defaultCountry={defaultCountry} />)}
            {gridVisibility[2] && (<DocumentDetails documentType={documentType} setDocumentsList={setDocumentsList} documentsList={documentsList} />)}
            {gridVisibility[3] && (<Activity activityRating={activityRating} language={language} woContact={woContact} activityStatus={activityStatus} setActivityList={setActivityList} activityList={activityList} ativityLeadType={ativityLeadType} />)}

            {gridVisibility[4] && (<GLAccount gLAccounts={gLAccounts} categoryMix={categoryMix} transectionData={transectionData} countriesList={countriesList} setGLAccounts={setGLAccounts} taxList={taxList} acountCodes={acountCodes} />)}
            {gridVisibility[5] && (<PreferenceDetails
                setPreferenceList={setPreferenceList} prefIntrest={prefIntrest} prefBuying={prefBuying} Properties={Properties} UnitTypeDesc={UnitTypeDesc}
                preferenceList={preferenceList} locationMaster={locationMaster} UnitClass={UnitClass} UnitView={UnitView} UnitModel={UnitModel}
                packageName={propertylist} bedRooms={bedRooms} />)}
            {gridVisibility[8] && (<DependentDetails setDependentList={setDependentList} addAddressType={addAddressType}
                dependentList={dependentList} countriesList={countriesList} cityList={cityList}
                currencyPrecision={currencyPrecision}
                defaultCountry={defaultCountry} />)}
        </div>

    );
};
export default UpdateCustomerMaster;